module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDoelstellingen5FA7C4.12b29eab.png";